var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('img',{staticClass:"logo",attrs:{"src":_vm.logo,"alt":""}}),_c('div',{staticClass:"slogan"},[_vm._v(" 链接云拥有多个主管税务机关颁发的《委托代征证书》，与国内多家银行和头部支付公司建立资金监管和支付结算战略合作，保证资金安全。 ")]),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tips"},[_c('p',[_vm._v("TO PAY TAXES ACCORDING TO LAW")]),_c('p',[_vm._v("依法诚信纳税是中国公民的义务")])])
}]

export { render, staticRenderFns }